import { useToasts } from "react-toast-notifications";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useLandingPageAnalyticsContext } from "@features/landing-page-analytics/hooks";
import { AttributionWindowSelect } from "@pages/sales/report-body-control/attribution-window-select";
import { NbAccountingModeSelect } from "@pages/sales/report-body-control/nb-accounting-mode-select";
import { SecondaryButton } from "@shared/buttons";
import { AttributionModelSelect, GranularitySelect } from "@shared/selects";

export const TopBar = () => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { addToast } = useToasts();

  const {
    filters: {
      attributionModel,
      attributionWindow,
      accountingMode,
      level,
      dateRange,
      breakdownFilters,
      adQuery,
      urlQuery,
      advancedSearch,
    },
    setAttributionModel,
    setAttributionWindow,
    setAccountingMode,
    setLevel,
    setPage,
  } = useLandingPageAnalyticsContext();

  const pageContext = {
    attributionModel,
    attributionWindow,
    accountingMode,
    level,
    dateRange,
    breakdownFilters,
    adQuery,
    urlQuery,
    advancedSearch,
  };

  const isAttributionWindowVisible = accountingMode === "accrual";

  return (
    <div className="px-6 py-4 flex justify-between space-x-4 bg-white border-b border-gray-0">
      <div className="flex items-end space-x-3 grow">
        <AttributionModelSelect
          maxWidth="160px"
          attributionModel={attributionModel}
          onChange={(value) => {
            prettyLogEventPage({
              domain: "Landing Page Analytics",
              action: "onChange",
              additionalActionInfo: "Set Attribution Model",
              data: {
                newAttributionModel: value,
                pageContext,
              },
            });

            setPage(1);
            setAttributionModel(value);
          }}
        />
        {isAttributionWindowVisible && (
          <AttributionWindowSelect
            className="whitespace-nowrap"
            maxWidth="160px"
            attributionModel={attributionModel}
            attributionWindow={attributionWindow}
            timeGranularity="daily"
            onChange={(value) => {
              prettyLogEventPage({
                domain: "Landing Page Analytics",
                action: "onChange",
                additionalActionInfo: "Set Attribution Window",
                data: {
                  newAttributionWindow: value,
                  pageContext,
                },
              });

              setPage(1);
              setAttributionWindow(value);
            }}
          />
        )}
        <NbAccountingModeSelect
          maxWidth="190px"
          nbAccountingMode={accountingMode}
          isLoading={false}
          icon={null}
          onChange={(value) => {
            prettyLogEventPage({
              domain: "Landing Page Analytics",
              action: "onChange",
              additionalActionInfo: "Set Accounting Mode",
              data: {
                newAccountingMode: value,
                pageContext,
              },
            });

            setPage(1);
            setAccountingMode(value);
          }}
        />
        <GranularitySelect
          maxWidth="120px"
          hasPlatform={false}
          icon={null}
          label="LEVEL"
          granularity={level}
          onChange={(value) => {
            prettyLogEventPage({
              domain: "Landing Page Analytics",
              action: "onChange",
              additionalActionInfo: "Set Level",
              data: {
                newLevel: value,
                pageContext,
              },
            });

            setPage(1);
            setLevel(value);
          }}
        />
      </div>
      <div className="flex space-x-2 items-start pt-[21px]">
        <SecondaryButton
          className="font-bold flex items-center gap-2 h-8 py-0"
          onClick={async () => {
            await navigator.clipboard.writeText(window.location.href);
            addToast("Copied to clipboard!", { appearance: "success" });
          }}
        >
          <i className="fa-regular fa-sharp fa-link text-sm" />
          SHARE
        </SecondaryButton>
      </div>
    </div>
  );
};
